import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
// import { ChooseIconComponent } from 'vhautoweb-components';
import { ChooseIconComponent } from 'vhobjects-service';
import { MatDialog } from '@angular/material/dialog';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, Injectable } from '@angular/core';
import { FunctionService } from 'vhobjects-service/src/services';
@Component({
  selector: 'atw-export-bill-config',
  templateUrl: './export-bill-config.component.html',
  styleUrls: ['./export-bill-config.component.scss']
})
export class AtwExportBillConfig implements OnInit {
  @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any; // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() visible_config_tool = false; // biến kiểm tra đóng mở khi gọi hộp thoại

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  styles_field = [
    {
      title: 'Cấu hình chi tiết Hiệu ứng',
      index: 1,
    },
  ];

  fonts = [];
  effect_hover = [];
  effect_hover_data: any = {};

  dataAfterChange: any = {};
  arr_link_page: any;
  id_subproject: any = '';
  customize: any = {};
  width = 0;
  height = 0;
  /** Biến lưu cấu hình tự động dịch có đang bật không? Tránh gọi hàm getSetups_byFields quá nhiều lần */
  private isAutoTranslate: boolean;

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    private dialog: MatDialog,
    private vhEventMediator: VhEventMediator,
    public functionService: FunctionService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit(): void {
    this.vhQueryAutoWeb.getSetups_byFields({ type: { $in: ['auto_translate_language'] } })
      .then((res: any) => {
        this.isAutoTranslate = res.find((ele) => ele.type == 'auto_translate_language').auto_translate_language;
      });
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/fonts/fonts.json'),
      this.http.get('assets/data/effects/text.json'),
    ]).subscribe(([fonts, effects]: any) => {
      this.fonts = fonts;
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(
        (e) => e.type == this.staticdata[this.device + '_animation_type']
      );
    });
  }

  ngOnChanges(): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
  };
  typeGradient = [
    {
      type: 'linear-gradient',
      direction: '',
      name: 'Mặc định',
      img: '../../../../../assets/root/icon/user/gdDefault.png',
      deg: '180deg'
    },
    {
      type: 'linear-gradient',
      direction: 'to right,',
      name: 'Từ trái sang phải',
      img: '../../../../../assets/root/icon/user/gdToRight.png',
      deg: '90deg'
    },
    {
      type: 'linear-gradient',
      direction: 'to left,',
      name: 'Từ phải sang trái',
      img: '../../../../../assets/root/icon/user/gdToLeft.png',
      deg: '270deg'
    },
  ];

  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
        console.log('updateStaticData', bool);
      });
  }

  /**
   * Cập nhật Gradient
   */
  handleSetGradientText() {
    if (this.config['background-image'].gradient_check) {
      this.class['export-bill--content__text']['background-image'] = `linear-gradient(${this.config['background-image']['gradient_direction']} ${this.config['background-image']['gradient_arr_gradient']})`;
      this.class['export-bill--content__text']['-webkit-text-fill-color'] = 'transparent';
      this.class['export-bill--content__text']['-webkit-background-clip'] = 'text';
    }
    else {
      this.class['export-bill--content__text']['background-image'] = 'none';
      this.class['export-bill--content__text']['-webkit-text-fill-color'] = 'unset';
      this.class['export-bill--content__text']['-webkit-background-clip'] = 'unset';
    }
    this.updateObject();
  }
  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event) {
    this.config['background-image']['gradient_direction'] = direction.direction;
    this.handleSetGradientText();
  }
  /** Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');

    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }
  /** Xử lý lấy thông số giá trị background gradient
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundGradient(e) {
    this.config['background-image']['gradient_opacity'] = e.target.value;
    const newArr = this.config['background-image']['gradient_arr_gradient'].map((color) => {
      const parts = color.match(/(\d+(\.\d+)?)/g); // Tách các phần tử màu từ chuỗi rgba
      return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-image']['gradient_opacity'] / 100})`
    })
    this.config['background-image']['gradient_arr_gradient'] = newArr;
    
    this.handleSetGradientText();
  }
  openbgGradient() {
    if (isPlatformBrowser(this.platformId)) document.getElementById('input-gradient-current').click();
  }
  /**
  * Hàm này thực hiện thêm màu gradient vào array.
  *
  */
  addGradient() {
    this.config['background-image']['gradient_arr_gradient'].push(
      `rgba(${this.hexToRGB(this.config['background-image']['gradient_background_color'])}, ${this.config['background-image']['gradient_opacity'] / 100})`
    );
    this.handleSetGradientText();
  }
  /**  Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
  * @param index : vị trí phần tử muốn xóa
  */
  deleteGradient(index) {
    this.config['background-image']['gradient_arr_gradient'].splice(index, 1);
    this.handleSetGradientText();
  }

  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {
        
      })
  }

  /**
   * Hàm update class
   */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
        
      })
  }

  /**
   * Hàm update config`
   */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {
        
      })
  }

  /**
   * Hàm set lại vị tri checkmark , có thêm biến check_mark_positionY và check_mark_positionX để lưu lại vị trí
   * @param value giá trị cập nhật
   * @param position vị trí tương ứng horizontal : ngang; vertical : dọc
   */
  onChangePositionCheckmark(value: any, position : string){
    if(position == 'horizontal'){
      this.staticdata['check_mark_positionX'] = value;
      this.class['checkbox__selected--icon']['transform'] = `translate(-${value}%, -${this.staticdata['check_mark_positionY']}%)`;
    }
   else if(position == 'vertical'){
    this.staticdata['check_mark_positionY'] = value;
      this.class['checkbox__selected--icon']['transform'] = `translate(-${this.staticdata['check_mark_positionX']}%, -${value}%)`;
    }
    this.updateStaticData();
    this.updateClass();
  }

  /**
  * Hàm thay đổi cấu hình đổ bóng
  */
  onChangeShadow() {
    if (this.config['box-shadow']['shadow_check'] === false) {
      this.config['box-shadow']['offset_x'] = 0;
      this.config['box-shadow']['offset_y'] = 0;
      this.config['box-shadow']['blur_radius'] = 0;
      this.config['box-shadow']['shadow_color'] = '#333';
    }
    this.class['checkbox__around']['box-shadow'] = `${this.config['box-shadow']['offset_x']}px ${this.config['box-shadow']['offset_y']}px ${this.config['box-shadow']['blur_radius']}px ${this.config['box-shadow']['shadow_color']}`;
  }

  /**
   * Hàm mở ra hộp thoại chọn icon
   */
  openDialogChooseIcon() {
    this.visible_config_tool=false;
    const dialogRef = this.dialog.open(ChooseIconComponent, {
      width: '90vw',
      height: '100vh',
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.staticdata.icon_name=result.icon;
        this.updateStaticData()
      }
      this.visible_config_tool=true;
    });
  }

   /**
   *Hàm update class vào database, và gửi cập nhật width, height cho object-selected
   */
  updateClassAndWidthHeight() {
    if (isPlatformBrowser(this.platformId)) {
      this.width = document.getElementById(this.objectChoosing._id).clientWidth;
      this.height = document.getElementById(this.objectChoosing._id).clientHeight;
      this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
      this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
        .then((bool: any) => {

        })
    }
  }

  changeSizeCheckbox(field, value){
    this.config['checkbox'][field] = value;
    if(value) this.class['checkbox'][field] = this.config['checkbox'][field] + 'px';
    this.updateConfig()
    this.updateClass()
  }

  /**
   * Update nội dung 
   * @example
   * data = [ { langCode: 'vi', translatedText: 'Bản đồ Việt Nam' } ]
   */
  updateContent() {
    if (this.isAutoTranslate) {
      this.functionService.translateToMultipleLanguages(
        this.staticdata['content_' + this.functionService.selectedLanguageCode]
      )
      .subscribe({
        next: (data) => {
          // console.log('data', data)
          this.functionService.multi_languages.forEach(lang => {
            if (
              this.functionService.selectedLanguageCode != lang.code 
              && !this.staticdata['content_' + lang.code]
            ) {
              this.staticdata['content_' + lang.code] = data.find(
                item => item.langCode == lang.code
              ).translatedText;
            }
          });
          this.updateStaticData();
        },
        error: (err) => {
          console.error('Lỗi dịch thuật:', err);
        }
      });
    } else {
      this.updateStaticData();
    }
  }
}
